// assets
import {
  HomeFilled,
  MessageFilled,
  CustomerServiceFilled
} from '@ant-design/icons';

// icons
const icons = {
  HomeFilled,
  MessageFilled,
  CustomerServiceFilled
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const ddpsHome = {
  id: 'app-home',
  title: 'Home',
  type: 'group',
  app: 'ddps',
  children: [
      {
          id: 'home',
          title: 'DDPS Home',
          type: 'item',
          url: '/ddps',
          icon: icons.HomeFilled,
          breadcrumbs: false
      },

  ]
};

export default ddpsHome;
